import { Features } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

/**
 * Custom hook to check if UserRoleManagmentFeature is available.
 * This is used to conditionally enable/disable user role management functionality.
 * @returns {{ isUserRoleManagementFeatureEnabled: boolean}} An object containing:
 *   - isUserRoleManagementFeatureEnabled: boolean - Whether the UserRoleManagmentFeature is enabled
 */
export const useUserRoleManagementFeatureGate = () => {
  // Check if UserRoleManagmentFeature is available using existing hook
  const { isFeatureEnabled } = usePlanFeatureGate(Features.UserRoleManagementFeature);

  return {
    isUserRoleManagementFeatureEnabled: isFeatureEnabled,
  };
};
